import { useDropzone } from "react-dropzone";
import { notifier } from "../utils/notifier.tsx";

export const useFontFileDialog = ({
  onFontLoaded,
}: {
  onFontLoaded?: (family: string, file: File) => void;
}) => {
  // XXX: We do not actually support drag-n-drop for font files
  // but we still use this hook as it provides a nice file dialog
  // out-of-the-box and it is already part of our dependencies.
  const dropzone = useDropzone({
    multiple: false,
    noClick: true,
    accept: {
      "font/ttf": [".ttf"],
      "font/otf": [".otf"],
      "font/woff": [".woff"],
      "font/woff2": [".woff2"],
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length === 0) {
        notifier.error("Please select a font file");
        return;
      }

      const fontFile = acceptedFiles[0];
      onFontLoaded?.(fontFile.name.split(".")[0], fontFile);
    },
  });

  return dropzone.open;
};
